import { useTranslation } from 'react-i18next';

export function Footer() {
  const { t } = useTranslation();

  const currentYear = new Date().getFullYear();

  const openLegalPage = (page: string) => {
    // Just change hash, scroll position is handled in App.tsx
    window.location.hash = `#/${page}`;
  };

  return (
    <footer className="bg-[#151515] text-boho-cream border-t border-white/5 mt-auto">
      <div className="container mx-auto px-4 sm:px-6 py-6 sm:py-8 md:py-10 lg:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-6 md:gap-8 mb-6 sm:mb-8">
          {/* Company Info */}
          <div>
            <h3 className="font-serif font-bold text-base sm:text-lg mb-3 sm:mb-4 text-posterden-red tracking-wide">
              POSTER'S DEN
            </h3>
            <ul className="space-y-2 sm:space-y-2.5 text-xs sm:text-sm text-boho-beige/70">
              <li>
                <button
                  onClick={() => openLegalPage('company')}
                  className="hover:text-posterden-red transition-colors text-left min-h-[44px] sm:min-h-0 py-2 sm:py-0 flex items-center"
                >
                  {t('footer.company.about', { defaultValue: 'About Us' })}
                </button>
              </li>
              <li>
                <button
                  onClick={() => openLegalPage('contact')}
                  className="hover:text-posterden-red transition-colors text-left min-h-[44px] sm:min-h-0 py-2 sm:py-0 flex items-center"
                >
                  {t('footer.company.contact', { defaultValue: 'Contact' })}
                </button>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-serif font-semibold text-base sm:text-lg mb-3 sm:mb-4 text-white">
              {t('footer.legal.title', { defaultValue: 'Legal' })}
            </h3>
            <ul className="space-y-2 sm:space-y-2.5 text-xs sm:text-sm text-boho-dark/80">
              <li>
                <button
                  onClick={() => openLegalPage('privacy')}
                  className="hover:text-posterden-red transition-colors text-left min-h-[44px] sm:min-h-0 py-2 sm:py-0 flex items-center"
                >
                  {t('footer.legal.privacy', { defaultValue: 'Privacy Policy' })}
                </button>
              </li>
              <li>
                <button
                  onClick={() => openLegalPage('terms')}
                  className="hover:text-posterden-red transition-colors text-left min-h-[44px] sm:min-h-0 py-2 sm:py-0 flex items-center"
                >
                  {t('footer.legal.terms', { defaultValue: 'Terms of Service' })}
                </button>
              </li>
              <li>
                <button
                  onClick={() => openLegalPage('accessibility')}
                  className="hover:text-posterden-red transition-colors text-left min-h-[44px] sm:min-h-0 py-2 sm:py-0 flex items-center"
                >
                  {t('footer.legal.accessibility', { defaultValue: 'Accessibility' })}
                </button>
              </li>
            </ul>
          </div>

          {/* Customer Service */}
          <div>
            <h3 className="font-serif font-semibold text-base sm:text-lg mb-3 sm:mb-4 text-boho-dark">
              {t('footer.customer.title', { defaultValue: 'Customer Service' })}
            </h3>
            <ul className="space-y-2 sm:space-y-2.5 text-xs sm:text-sm text-boho-dark/80">
              <li>
                <button
                  onClick={() => openLegalPage('shipping')}
                  className="hover:text-posterden-red transition-colors text-left min-h-[44px] sm:min-h-0 py-2 sm:py-0 flex items-center"
                >
                  {t('footer.customer.shipping', { defaultValue: 'Shipping & Returns' })}
                </button>
              </li>
              <li>
                <button
                  onClick={() => openLegalPage('withdrawal')}
                  className="hover:text-posterden-red transition-colors text-left min-h-[44px] sm:min-h-0 py-2 sm:py-0 flex items-center"
                >
                  {t('footer.customer.withdrawal', { defaultValue: 'Right of Withdrawal' })}
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="min-w-0">
            <h3 className="font-serif font-semibold text-base sm:text-lg mb-3 sm:mb-4 text-boho-dark">
              {t('footer.contact.title', { defaultValue: 'Contact' })}
            </h3>
            <ul className="space-y-2 sm:space-y-2.5 text-xs sm:text-sm text-boho-dark/80">
              <li className="leading-relaxed break-words" style={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}>{t('footer.contact.email', { defaultValue: 'Email: info@postersden.bd' })}</li>
              <li className="leading-relaxed break-words italic text-boho-beige/50 mt-2">Designed in Bohemia, EU</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-boho-gold/20 pt-4 sm:pt-6 mt-4 sm:mt-6">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-3 sm:gap-4 text-xs sm:text-sm text-boho-beige/40">
            <p className="text-center sm:text-left font-serif">
              © {currentYear} {t('footer.copyright', { defaultValue: "Poster's Den. All rights reserved." })}
            </p>
            <div className="flex gap-3 sm:gap-4 items-center">
              <button
                onClick={() => openLegalPage('privacy')}
                className="hover:text-posterden-red transition-colors min-h-[44px] sm:min-h-0 px-2 sm:px-0 flex items-center"
              >
                {t('footer.legal.privacy', { defaultValue: 'Privacy' })}
              </button>
              <span className="hidden sm:inline text-boho-gold/50">•</span>
              <button
                onClick={() => openLegalPage('terms')}
                className="hover:text-posterden-red transition-colors min-h-[44px] sm:min-h-0 px-2 sm:px-0 flex items-center"
              >
                {t('footer.legal.terms', { defaultValue: 'Terms' })}
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
